module.exports = __webpack_public_path__ + "img/PSSS-J-1.9ec789e6.svg";